const sidebarPanel = {
    bindings: {
        name: '<',
        items: '<',
        selected: '<',
        onSelect: '<',
        onShowChange: '<',
        selectOne: '<',
        show: '<',
        loading: '<',
    },
    templateUrl: '/modules/common/sidebar/sidebar-panel/sidebar-panel.html',
    controller: 'SidebarPanelController',
};

angular
    .module('sidebar.module')
    .component('sidebarPanel', sidebarPanel);